module.exports = __webpack_public_path__ + "static/media/company-logo-10.9430e18b.png";